/* JOLI POT, fiches par occasion : suspensions macramé à l'étape 4 « Les petits plus » (assets/jp-occasion-susp.js, 23/10/2026).
   Chargé par snippets/jp-occasion-etapes.liquid après assets/jp-occasion-etapes.js (outils partagés dans window.JPOE).
   Mêmes règles que le configurateur (assets/jp-configurateur.js) : liste des suspensions lue dans #jp-config (réglages du thème
   jp_susp1..3, sinon liste par défaut), modèles compatibles avec la taille choisie, prix lus sur les variantes, rien en 8 cm.
   Une seule suspension compatible : la carte se coche directement ; plusieurs : fenêtre de choix. Astuce coupelle sous la grille.
   Carte posée à la fin de la grille des petits plus du configurateur (boîte cadeau, carte à planter, carte LaMariesGarden).
   Prix ajouté via window.jpPrixSupp, ligne ajoutée au panier avec le pot via window.jpItemsSupp (en chaînant les crochets existants). */
(function () {
  var J = window.JPOE;
  if (!J || !J.form) return;
  var form = J.form, C = J.C, K = J.K, variantes = J.variantes, P_TAILLE = J.P_TAILLE, P_COUP = J.P_COUP;
  var radios = J.radios, valeur = J.valeur, varianteCourante = J.varianteCourante, formater = J.formater, signaler = J.signaler, lisse = J.lisse;
  var TXT = {
    nom: 'Suspension\nmacramé', titre: 'Choisissez votre suspension', aucune: 'Non merci', retirer: 'Retirer', ajouter: 'Ajouter', garder: 'Garder',
    voir: 'Voir les modèles', changer: 'Changer de modèle', astuce: "Pensez à la coupelle pour éviter d'abîmer la suspension.",
    ajoutCoupelle: 'Ajouter la coupelle', coupelleOk: 'Coupelle ajoutée', annuler: 'Annuler', modeles: ' modèles, dès '
  };
  var SUSP = (C.macrame !== false && P_TAILLE) ? (K.suspensions || []) : [];
  var choisie = null, coupelleAvant = null, carte = null, zoneAstuce = null;
  function taille() { var m = valeur(P_TAILLE).match(/\d+/); return m ? m[0] : null; }
  function compatibles() {
    var t = taille(), l = [];
    if (!t) return l;
    SUSP.forEach(function (sp) {
      var regle = (sp.tailles || []).filter(function (x) { return String(x).split('=')[0] === t; })[0];
      if (!regle) return;
      var filtre = String(regle).split('=')[1] || '';
      (sp.variantes || []).filter(function (va) { return va.dispo && (!filtre || va.titre.indexOf(filtre) > -1); }).forEach(function (va) {
        var suf = /default title/i.test(va.titre) ? '' : ' ' + va.titre.replace(/^Diam[eè]tre\s*/i, 'ø ');
        l.push({ id: va.id, prix: va.prix, nom: sp.nom + suf, collab: sp.collab || '', image: sp.image, photos: (sp.photos && sp.photos.length) ? sp.photos : (sp.image ? [sp.image] : []) });
      });
    });
    return l;
  }
  function grande(src) { return String(src || '').replace(/([?&])width=\d+/, '$1width=1200').replace(/&(height=\d+|crop=[a-z_]+)/gi, ''); }
  function zoom(src) {
    var f = document.createElement('div');
    f.className = 'jp-ap-fen';
    f.setAttribute('role', 'dialog'); f.setAttribute('aria-modal', 'true');
    f.innerHTML = '<div><img alt=""><button type="button" aria-label="Fermer">×</button></div>';
    f.querySelector('img').src = grande(src);
    var fermer = function () { f.remove(); document.removeEventListener('keydown', esc); };
    var esc = function (e) { if (e.key === 'Escape') fermer(); };
    f.addEventListener('click', function (e) { if (e.target === f || e.target.tagName === 'BUTTON') fermer(); });
    document.addEventListener('keydown', esc);
    document.body.appendChild(f);
    f.querySelector('button').focus();
  }
  function el(tag, cls, txt) { var x = document.createElement(tag); if (cls) x.className = cls; if (txt != null) x.textContent = txt; return x; }
  function coupelleRadio() { return P_COUP ? radios(P_COUP).filter(function (r) { return !/sans/i.test(r.value); })[0] : null; }
  function astuceCoupelle() {
    var bloc = el('div', 'jp-susp__astuce');
    var avec = coupelleRadio(), li = avec ? avec.closest('li') : null;
    if (!avec || (li && li.style.display === 'none')) return bloc;
    if (!avec.checked) coupelleAvant = null;
    if (avec.checked && !coupelleAvant) return bloc;
    var avant = coupelleAvant || radios(P_COUP).filter(function (r) { return r.checked; })[0];
    var cur = varianteCourante();
    var cible = variantes.filter(function (v) { for (var k = 1; k <= 3; k++) { var att = k === P_COUP ? avec.value : valeur(k); if (att && v['option' + k] !== att) return false; } return true; })[0];
    var diff = cur && cible ? cible.price - cur.price : 0;
    var ecrire = function (ajoutee) {
      bloc.innerHTML = '';
      var ligne = el('p', 'jp-pop__prix'), b = el('button', 'jp-lien-photo');
      b.type = 'button';
      if (!ajoutee) {
        ligne.appendChild(document.createTextNode(TXT.astuce + ' '));
        b.textContent = TXT.ajoutCoupelle + (diff > 0 ? ' (+' + formater(diff) + ')' : '');
        b.addEventListener('click', function (e) { e.stopPropagation(); coupelleAvant = avant; avec.checked = true; avec.dispatchEvent(new Event('change', { bubbles: true })); ecrire(true); });
      } else {
        ligne.appendChild(document.createTextNode(TXT.coupelleOk + ' · '));
        b.textContent = TXT.annuler;
        b.addEventListener('click', function (e) { e.stopPropagation(); coupelleAvant = null; if (avant) { avant.checked = true; avant.dispatchEvent(new Event('change', { bubbles: true })); } ecrire(false); });
      }
      ligne.appendChild(b);
      bloc.appendChild(ligne);
    };
    ecrire(avec.checked);
    return bloc;
  }
  function majSusp() {
    if (!carte) return;
    var l = compatibles();
    if (choisie && !l.some(function (x) { return x.id === choisie.id; })) choisie = null;
    carte.style.setProperty('display', l.length ? 'flex' : 'none', 'important');
    carte.innerHTML = '';
    if (zoneAstuce) zoneAstuce.innerHTML = '';
    carte.classList.toggle('is-choisi', !!choisie);
    if (!l.length) { prix(); return; }
    carte.dataset.mode = l.length === 1 ? 'direct' : 'fenetre';
    if (l.length === 1) { carte.setAttribute('aria-pressed', choisie ? 'true' : 'false'); carte.removeAttribute('aria-haspopup'); }
    else { carte.removeAttribute('aria-pressed'); carte.setAttribute('aria-haspopup', 'dialog'); }
    var it = l.length === 1 ? l[0] : choisie;
    var photo = it ? (it.photos && it.photos[0]) || it.image : (SUSP[0] && SUSP[0].image);
    if (photo) { var cadre = el('span', 'jp-extra__photo'), im = el('img'); im.src = photo; im.alt = it ? it.nom.replace('\n', ' ') : ''; im.loading = 'lazy'; cadre.appendChild(im); carte.appendChild(cadre); }
    carte.appendChild(el('span', 'jp-extra__nom', it ? it.nom : TXT.nom));
    if (it && it.collab) carte.appendChild(el('span', 'jp-pop__collab jp-extra__collab', it.collab));
    var mini = Math.min.apply(null, l.map(function (x) { return x.prix; }));
    carte.appendChild(el('small', 'jp-extra__prix', it ? '+' + formater(it.prix) : l.length + TXT.modeles + formater(mini)));
    if (l.length > 1) carte.appendChild(el('span', 'jp-extra__voir', choisie ? TXT.changer : TXT.voir));
    if (zoneAstuce && (choisie || coupelleAvant) && carte.style.display !== 'none') zoneAstuce.appendChild(astuceCoupelle());
    prix();
  }
  var majPrixAttente = 0;
  function prix() { clearTimeout(majPrixAttente); majPrixAttente = setTimeout(signaler, 0); }
  function fenetre() {
    var l = compatibles();
    if (!l.length) return;
    var retour = document.activeElement;
    var fond = el('div', 'jp-pop'), boite = el('div', 'jp-pop__boite jp-pop__boite--susp');
    boite.setAttribute('role', 'dialog'); boite.setAttribute('aria-modal', 'true'); boite.setAttribute('aria-label', TXT.titre);
    var x = el('button', 'jp-pop__fermer'); x.type = 'button'; x.setAttribute('aria-label', 'Fermer'); x.textContent = '×';
    var grille = el('div', 'jp-susp__grille');
    var fermer = function () { fond.remove(); document.documentElement.classList.remove('jp-pop-ouvert'); document.removeEventListener('keydown', clavier); majSusp(); try { (retour || carte).focus({ preventScroll: true }); } catch (e) {} };
    var clavier = function (e) { if (e.key === 'Escape') fermer(); };
    l.forEach(function (it) {
      var b = el('div', 'jp-susp__carte' + (choisie && choisie.id === it.id ? ' is-choisi' : ''));
      b.setAttribute('role', 'button'); b.tabIndex = 0;
      b.setAttribute('aria-label', it.nom.replace('\n', ' ') + ', +' + formater(it.prix));
      if (it.photos.length) {
        var z = el('div', 'jp-carrousel'), im = el('img'), idx = 0, pts = el('div', 'jp-carrousel__points');
        im.alt = it.nom.replace('\n', ' ');
        var voir = function (i) { idx = (i + it.photos.length) % it.photos.length; im.src = it.photos[idx]; [].forEach.call(pts.children, function (p, k) { p.classList.toggle('is-actif', k === idx); }); };
        z.appendChild(im);
        if (it.photos.length > 1) {
          ['prec', 'suiv'].forEach(function (s) {
            var f = el('button', 'jp-carrousel__fleche jp-carrousel__fleche--' + s, s === 'prec' ? '‹' : '›');
            f.type = 'button'; f.setAttribute('aria-label', s === 'prec' ? 'Photo précédente' : 'Photo suivante');
            f.addEventListener('click', function (e) { e.stopPropagation(); voir(idx + (s === 'prec' ? -1 : 1)); });
            z.appendChild(f);
          });
          it.photos.forEach(function () { pts.appendChild(el('span')); });
          z.appendChild(pts);
        }
        var lp = el('span', 'jp-loupe');
        lp.setAttribute('role', 'button'); lp.setAttribute('aria-label', 'Voir la photo en grand'); lp.tabIndex = 0;
        lp.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><line x1="15.5" y1="15.5" x2="21" y2="21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        lp.addEventListener('click', function (e) { e.stopPropagation(); zoom(it.photos[idx]); });
        lp.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); zoom(it.photos[idx]); } });
        z.appendChild(lp);
        voir(0);
        b.appendChild(z);
      }
      b.appendChild(el('span', null, it.nom));
      if (it.collab) b.appendChild(el('span', 'jp-pop__collab', it.collab));
      b.appendChild(el('small', null, '+' + formater(it.prix)));
      var prendre = function () { choisie = it; fermer(); };
      b.addEventListener('click', prendre);
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); prendre(); } });
      grille.appendChild(b);
    });
    var aucune = el('button', 'jp-pop__autre', choisie ? TXT.retirer : TXT.aucune);
    aucune.type = 'button';
    aucune.addEventListener('click', function () { choisie = null; fermer(); });
    x.addEventListener('click', fermer);
    fond.addEventListener('click', function (e) { if (e.target === fond) fermer(); });
    boite.appendChild(x);
    if (l.length > 1) boite.appendChild(el('p', 'jp-pop__nom', TXT.titre));
    boite.appendChild(grille);
    if (l.length > 1) {
      var pts = el('div', 'jp-susp__points');
      l.forEach(function (it, k) {
        var pt = el('button'); pt.type = 'button'; pt.setAttribute('aria-label', it.nom.replace('\n', ' '));
        pt.addEventListener('click', function () { var c = grille.children[k]; if (c) grille.scrollTo({ left: c.offsetLeft - grille.offsetLeft - (grille.clientWidth - c.clientWidth) / 2, behavior: lisse ? 'smooth' : 'auto' }); });
        pts.appendChild(pt);
      });
      var majPts = function () {
        var centre = grille.scrollLeft + grille.clientWidth / 2, actif = 0, mieux = Infinity;
        [].forEach.call(grille.children, function (c, k) { var d = Math.abs(c.offsetLeft - grille.offsetLeft + c.clientWidth / 2 - centre); if (d < mieux) { mieux = d; actif = k; } });
        [].forEach.call(pts.children, function (pt, k) { pt.classList.toggle('is-actif', k === actif); });
      };
      grille.addEventListener('scroll', majPts, { passive: true });
      boite.appendChild(pts);
      setTimeout(majPts, 50);
    }
    boite.appendChild(astuceCoupelle());
    var actions = el('div', 'jp-susp__actions');
    if (l.length === 1) {
      var ok = el('button', 'jp-pop__ok', choisie && choisie.id === l[0].id ? TXT.garder : TXT.ajouter + ' (+' + formater(l[0].prix) + ')');
      ok.type = 'button';
      ok.addEventListener('click', function () { choisie = l[0]; fermer(); });
      actions.appendChild(ok);
    }
    actions.appendChild(aucune);
    boite.appendChild(actions);
    fond.appendChild(boite);
    document.body.appendChild(fond);
    document.documentElement.classList.add('jp-pop-ouvert');
    document.addEventListener('keydown', clavier);
    var premier = grille.querySelector('.is-choisi') || grille.firstChild;
    if (premier) try { premier.focus({ preventScroll: true }); } catch (e) {}
  }
  function poserSusp() {
    if (carte || !SUSP.length) return !!carte;
    var grille = form.querySelector('.jp-extras');
    if (!grille) return false;
    carte = el('button', 'jp-extra jpoe-susp');
    carte.type = 'button';
    carte.dataset.cle = 'susp';
    grille.appendChild(carte);
    zoneAstuce = el('div');
    zoneAstuce.id = 'jpoe-susp-astuce';
    grille.parentNode.insertBefore(zoneAstuce, grille.nextSibling);
    carte.addEventListener('click', function () {
      if (carte.dataset.mode === 'direct') { choisie = choisie ? null : compatibles()[0]; majSusp(); }
      else fenetre();
    });
    var prevP = window.jpPrixSupp, prevI = window.jpItemsSupp;
    var actif = function () { return !!(choisie && carte.style.display !== 'none'); };
    window.jpPrixSupp = function () { var t = 0; if (typeof prevP === 'function') { try { t = prevP() || 0; } catch (e) {} } return t + (actif() ? choisie.prix : 0); };
    window.jpItemsSupp = function (items, qte, props) {
      if (typeof prevI === 'function') { try { prevI(items, qte, props); } catch (e) {} }
      if (actif()) items.push({ id: choisie.id, quantity: qte });
    };
    form.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.SizeSwatch__Radio, .ColorSwatch__Radio')) setTimeout(majSusp, 60);
    });
    majSusp();
    var g = carte.parentNode;
    if (g && g.style.display === 'none') g.style.setProperty('display', 'grid', 'important');
    return true;
  }

  var essais = 0;
  function lancer() { if (!poserSusp() && SUSP.length && essais++ < 40) setTimeout(lancer, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer); else lancer();
  window.addEventListener('load', lancer);
})();
